import { getType } from "typesafe-actions";
import * as actions from "../appBreadcrumbActions";
import _ from "lodash";

export interface Breadcrumb {
  to: string;
  displayName: string;
}

const defaultState: Breadcrumb[] = [];

export const reducer = (state = defaultState, action: actions.AppBreadcrumbActions): Breadcrumb[] => {
  switch (action.type) {
    case getType(actions.addBreadcrumbAction): {
      if (_.isEqual(state[state.length - 1], action.payload)) {
        return state;
      }
      const newState = [...state];
      const index = newState.findIndex(
        (x) => x.displayName === action.payload.displayName && x.to === action.payload.to
      );
      if (index === -1) {
        newState.push(action.payload);
      } else {
        newState.length = index + 1;
      }
      return newState;
    }
    case getType(actions.breadcrumbClickedAction): {
      const newState = [...state];
      const index = newState.findIndex(
        (x) => x.displayName === action.payload.displayName && x.to === action.payload.to
      );
      newState.length = index + 1 ?? 1;
      if (newState.length === state.length) return state;
      return newState;
    }
    case getType(actions.setBreadcrumbsAction): {
      return action.payload;
    }
    default:
      return state;
  }
};

export default reducer;
